/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindCatalogProductsQueryResponse,
  FindCatalogProductsQueryParams,
} from "../types/FindCatalogProducts.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findCatalogProductsQueryKey = (
  params: FindCatalogProductsQueryParams
) =>
  [
    { url: "/v1/product/find-catalog-products" },
    ...(params ? [params] : []),
  ] as const

export type FindCatalogProductsQueryKey = ReturnType<
  typeof findCatalogProductsQueryKey
>

/**
 * @summary Find catalog products
 * {@link /v1/product/find-catalog-products}
 */
export async function findCatalogProducts(
  params: FindCatalogProductsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindCatalogProductsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/product/find-catalog-products`,
    params,
    ...requestConfig,
  })
  return res
}

export function findCatalogProductsQueryOptions(
  params: FindCatalogProductsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findCatalogProductsQueryKey(params)
  return queryOptions<
    ResponseConfig<FindCatalogProductsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindCatalogProductsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      return findCatalogProducts(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find catalog products
 * {@link /v1/product/find-catalog-products}
 */
export function useFindCatalogProducts<
  TData = ResponseConfig<FindCatalogProductsQueryResponse>,
  TQueryData = ResponseConfig<FindCatalogProductsQueryResponse>,
  TQueryKey extends QueryKey = FindCatalogProductsQueryKey,
>(
  params: FindCatalogProductsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindCatalogProductsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findCatalogProductsQueryKey(params)

  const query = useQuery(
    {
      ...findCatalogProductsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
